import { PostCommonT, PostableOwner } from '~/state/post/_common';

export type PostableOwnerWithType = PostableOwner & {
  userType: 'corp' | 'org';
};

export function getOwner(post: PostCommonT): PostableOwnerWithType {
  const maybeCorp = post.postable_corporate || post.corporate;
  const maybeOrg = post.postable_organization;

  if (maybeCorp) {
    return { ...maybeCorp, userType: 'corp' };
  } else if (maybeOrg) {
    return { ...maybeOrg, userType: 'org' };
  } else {
    throw new Error(`post don't have <'postable_corporate' | 'postable_organization' | 'corporate'>

    post = ${JSON.stringify(post, null, 2)}`);
  }
}
